module.exports = __webpack_public_path__ + "static/img/psLogoN.0aeb3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/psLogoN.png
// module id = nu5L
// module chunks = 2